import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class DiscountType extends Form {
  static contextType = PopUpContext;

  state = {
    data: {
      name: "",
      name_en: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { data } = this.state;

    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.name = edit.name;
      data.name_en = edit.name_en;
    }

    this.setState({ data });
  };

  schema = {
    name: Joi.string().max(64).required(),
    name_en: Joi.string().max(64).required(),
  };

  doSubmit = async () => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      if (popUp?.edit) {
        await db
          .edit(`students/discounts/types/${popUp?.edit?.id}`, __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      } else {
        await db
          .save("students/discounts/types", __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      }
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditDiscount : lbl.AddDiscount}</p>
          </div>
          <div className="form-inputs">
            {this.renderInput("name", "نام (فارسی)")}
            {this.renderInput("name_en", "نام (انگلیسی)")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default DiscountType;
